"use strict";
exports.__esModule = true;
var Squarelate_1 = require("./Squarelate");
exports["default"] = Squarelate_1.Squarelate;
Object.assign(module.exports, Squarelate_1.Squarelate);
//# sourceMappingURL=index.js.map